import React from 'react';
import { Card, Button } from 'react-bootstrap';
//import { Rating } from './Rating';

const Space = ({ space }) => {
  return (
    <Card className='my-3 p-3 rounded'>
      <a href={`/space/${space._id}`}>
        <Card.Img src={space.image} variant='top' />
      </a>
      <Card.Body>
        <a href={`/space/${space._id}`}>
          <Card.Title as='div'>
            <h4>{space.gymName}</h4>
          </Card.Title>
        </a>
        <Card.Text as='div'>
          {/* <Rating value={space.rating} text={`${space.numReviews} reviews`} /> */}
          <p>Days Available: {space.classDates}</p>
          <p>Times Available: {space.classTime}</p>
          <p>Location: {space.gymName}</p>
          <p>Class Type: {space.classType}</p>
          <p>
            Date and Time: {space.classDate} @ {space.classTime}{' '}
          </p>
          <p>Max Occupency: {space.occupency}</p>
          <p>Price: {space.price}</p>
        </Card.Text>
      </Card.Body>
      <Card.Footer>
        <Button block href={`/space/${space._id}`}>
          Book Space
        </Button>
      </Card.Footer>
    </Card>
  );
};

export default Space;
